/* eslint-disable no-param-reassign */

import _ from 'underscore';
import pgrid from 'projection-grid';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';

import { parseErrors } from './error-map';
import { BulkEditView } from './bulk-edit-view';
import { PreviewGridOptions } from './preview-grid-options';
import { instrumentation } from '../hotel-center-shared';
import { bulkEditParams } from '../hotel-center-service';

const { getEntityWrapper, getOldValue, getNewValue } = globalContext.require('campaignui/feature/bulk-operation/edit-detail/detail-mapper');
const JobModel = globalContext.require('campaignui/feature/bulk-operation/util/bulk-edit-job');
const appState = globalContext.require('component/state/index');

function renderPreviewGrid(view, { el }) {
  const gridOptions = new PreviewGridOptions({ el });
  const grid = pgrid.factory({ vnext: true })
    .use(paginationPlugin)
    .use(placeholderPlugin)
    .create(gridOptions);

  view.grid = grid;

  grid.gridView.render();
}

function updatePreviewResults(view, data) {
  const jobModel = new JobModel(data);
  const results = _.result(data, 'BulkEditResults', []);
  const gridData = _.map(results, result => ({
    Name: getEntityWrapper(jobModel)(result).entityName,
    OriginalValue: getOldValue(jobModel)(result),
    NewValue: getNewValue(jobModel)(result),
  }));

  view.grid.dataSource.data = gridData;
  view.grid.gridView.refresh(true);
}

function onSave(view, bulkEditView) {
  const { selectionCount } = view.getState();

  if (selectionCount < 1) {
    throw new Error('Save should not be called when no item is selected.');
  }
  if (!view.validate()) {
    return;
  }
  const overViewPageScenario = instrumentation.overViewPage.create();

  view.activity = overViewPageScenario[view.activityName].create();
  view.activity.trace(`Task ${view.activityName} started`);
  view.setState({ showRequestError: false });
  view.bulkEditView.viewModel.disableAction(true);
  bulkEditView.save();
}

function completeCB(view, response) {
  view.activity.trace(`Task ${view.activityName} completed`);
  view.bulkEditView.viewModel.showProgress(false);
  view.bulkEditView.viewModel.disableAction(false);
  view.bulkEditView.$('.preview-container').hide();
  view.completeToast(response);
  view.trigger('saved', response);
}

function failedCB(view, response) {
  view.activity.error(JSON.stringify(response));
  const errors = parseErrors(response);

  view.setState({
    showRequestError: true,
    errors,
  });
  view.bulkEditView.viewModel.showProgress(false);
  view.bulkEditView.viewModel.disableAction(false);
  view.bulkEditView.$('.preview-container').hide();
  view.failedToast(response);
  view.trigger('error', response);
}

function onPreview(view) {
  view.bulkEditView.$('.preview-container').hide();
  const { selectionCount } = view.getState();

  if (selectionCount < 1) {
    throw new Error('Preview should not be called when no item is selected.');
  }
  if (!view.validate()) {
    return;
  }
  view.bulkEditView.preview();
}

function initBulkEditView(view) {
  const bulkEditView = new BulkEditView({
    blockerEl: view.el,
    showPreview: true,
    getBulkEditParams: options => view.getBulkEditParams(options),
    completeCB: response => completeCB(view, response),
    failedCB: response => failedCB(view, response),
    renderPreviewGrid: options => renderPreviewGrid(view, options),
    updatePreviewResults: data => updatePreviewResults(view, data),
  }).render();

  bulkEditView.$('.preview-container').addClass('bingadsgrid');
  bulkEditView.on('saveClicked', () => onSave(view, bulkEditView));
  bulkEditView.on('cancelClicked', () => view.onCancel());
  bulkEditView.on('previewClicked', () => onPreview(view, bulkEditView));
  view.bulkEditView = bulkEditView;
}


export class BulkEditPanelBase extends DeterministicView {
  initialize({
    completeToast,
    failedToast,
    activityName,
  }) {
    this.completeToast = completeToast;
    this.failedToast = failedToast;
    this.activityName = activityName;
    initBulkEditView(this);
  }

  getBatchAction() {
    throw new Error('Unimplemented BulkEditPanelBase.getBatchAction()');
  }

  getBulkEditParams({
    isPreview = false,
  } = {}) {
    const state = this.getState();
    const batchActions = this.getBatchAction(state);
    const entity = _.result({
      hotel: 'Hotel',
      hotelGroup: 'HotelGroup',
    }, state.scope);
    const { selectionCount, selectedItems, filter } = state;
    const campaignId = appState.get('subAccount_id') ? Number(appState.get('subAccount_id')) : null;
    const params = bulkEditParams({
      selectionCount,
      selectedIds: _.pluck(selectedItems, 'Id'),
      filter,
      batchActions,
      entity,
      campaignId,
      isPreview,
    });

    return params;
  }
  selectionAcrossPage() {
    const { mainGrid } = this;
    const { pgridPlugins } = mainGrid;

    return pgridPlugins &&
      pgridPlugins.crossPageSelectAll &&
      pgridPlugins.crossPageSelectAll.isAllSelected;
  }

  deselectAll() {
    if (this.selectionAcrossPage()) {
      this.mainGrid.pgridPlugins.crossPageSelectAll.deselectAll();
    } else {
      this.mainGrid.gridView.deselectAll();
    }
  }
  onEvent() {
    this.on('canceled', () => {
      this.trigger('hide');
    }, this);

    this.on('saved', () => {
      this.trigger('hide');
      this.deselectAll();
      this.mainGrid.gridView.refresh(true);
    }, this);

    this.on('error', () => {
      this.mainGrid.gridView.refresh(true);
    }, this);
  }
  onCancel() {
    this.setState({ showRequestError: false });
    this.bulkEditView.$('.preview-container').hide();
    this.trigger('canceled');
  }
}
